<template>
  <vxe-modal ref="modal" v-model="visible" title="设置财务批注" width="400px">
    <el-form :size="'mini'" :model="form">
      <el-form-item label="汇出时间" prop="remittanceDate">
        <el-date-picker
          type="date"
          placeholder="输入"
          value-format="yyyy-MM-dd"
          v-model="form.remittanceDate"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="批注" prop="annotation">
        <el-input type="textarea" :rows="4" placeholder="输入" v-model="form.annotation"></el-input>
      </el-form-item>
    </el-form>
    <div class="btnContainer">
      <el-button size="mini" @click="closeModal">关闭</el-button>
      <el-button size="mini" type="primary" @click="sure">确认</el-button>
    </div>
  </vxe-modal>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      // 表单
      form: {
        id: 0,
        remittanceDate: '',
        annotation: ''
      }
    }
  },
  methods: {
    // 确认操作
    async sure() {
      if (this.form.annotation.length > 400) {
        this.$message.error('字符长度不可超过400!')
        return
      }

      // 没有的情况下带上当日
      let remittanceDate = this.ykDateFormat('yyyy-MM-dd', this.form.remittanceDate)
      if (!remittanceDate) {
        remittanceDate = this.ykDateFormat('yyyy-MM-dd', new Date())
      }

      const { data: res } = await this.$http.put('/finance/funds_transfers_application/annotation', {
        ...this.form,
        remittanceDate
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('操作成功!')
      this.$emit('refresh')
      this.closeModal()
    },
    openModal(id, annotation = '') {
      const splitText = annotation.split('[批注]')
      let sourceAnnotation = ''
      if (splitText?.length > 0) {
        sourceAnnotation = splitText[splitText.length - 1]
      }

      const splitTextDate = splitText[0].split('[汇出日期]')
      let sourceRemittanceDate = ''
      if (splitTextDate?.length > 0) {
        sourceRemittanceDate = splitTextDate[splitTextDate.length - 1]
      }

      this.form = {
        id,
        remittanceDate: sourceRemittanceDate,
        annotation: sourceAnnotation
      }

      this.visible = true
    },
    closeModal() {
      this.visible = false
    }
  }
}
</script>
<style lang="less" scoped>
.btnContainer {
  display: flex;
  justify-content: flex-end;
}
.el-form-item {
  // margin: 0px !important;
  width: 100%;
  .el-input,
  .el-select,
  .el-date-picker {
    width: 100%;
  }
}
</style>
